// extracted by mini-css-extract-plugin
export default {"container":"loginInfo_container__F6QHN","imgContainer":"loginInfo_imgContainer__PUaZn","tiger":"loginInfo_tiger__2aJjs"};